var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.99996C11 10.2325 10.9104 10.4652 10.7314 10.6427L1.5648 19.7336C1.20661 20.0888 0.626596 20.0888 0.268639 19.7336C-0.0893173 19.3784 -0.0895464 18.8031 0.268639 18.4481L8.78718 9.99996L0.268638 1.55179C-0.0895472 1.19656 -0.0895472 0.621334 0.268638 0.266335C0.626824 -0.088665 1.20684 -0.088892 1.5648 0.266334L10.7314 9.35723C10.9104 9.53473 11 9.76746 11 9.99996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowRight);
export default __webpack_public_path__ + "static/media/carousel-arrow-right.5ad7e5e1ff941c84df9eb2686797dead.svg";
export { ForwardRef as ReactComponent };